<template>
  <div class="slider-parent" ref="parent">
    <ul
      class="slider-block"
      @touchmove.stop.prevent="move($event)"
      @touchstart.passive="moveStart($event)"
      @touchend="moveEnd($event)"
      :style="{ transform: 'translate3d(0, ' + y + 'px, 0)' }"
      ref="slider"
    >
      <template v-for="(item, index) in options">
        <li
          :key="item.name"
          :data-index="index"
          class="slider-item"
          :class="[current === index ? 'slider-selected' : '']"
        >{{item.name}}</li>
      </template>
    </ul>
    <slot></slot>
  </div>
</template>

<style scoped>
.slider-parent {
  flex: 1 1 100%;
  box-sizing: border-box;
  position: relative;
  width: 100%;
  height: 400px;
  overflow: hidden;
  border-top: 1px solid #ddd; /*no*/
}

.slider-block {
  position: absolute;
  top: 0;
  margin: 0;
  width: 100%;
  padding: 160px 0;
  z-index: 2;
}

.slider-item {
  text-align: center;
  font-size: 34px;
  height: 80px;
  line-height: 80px;
  transition: all 0.1s;
  color: rgb(187, 187, 187);
}

.slider-selected {
  color: #333;
  transform: scale(1.2, 1.2);
}
</style>

<script>
export default {
  data () {
    return {
      y: 0,
      current: 0,
      touchStartY: 0,
      tempY: 0,
      startTime: null,
      endTime: null,
      speed: 0,
      requestId: null,
      timer: null,
      parentHeight: 0,
      parentTop: 0,
      unitHeight: 0
    }
  },
  props: ['value', 'options'],
  watch: {
    options () {
      this.init()
    }
  },
  methods: {
    init () {
      let index = 0
      const flag = this.options.some((item, i) => {
        if (item.value === this.value) {
          index = i
          return true
        }
        return false
      })
      if (flag) {
        this.current = index
        this.y = -index * (this.parentHeight / 5)
        this.tempY = this.y
        this.$emit('selectChange', this.options[this.current])
      }
    },
    // 最终位移计算
    computePosition () {
      if (!this.$refs.slider) return
      let arr = Array.from(this.$refs.slider.children)
      const centerY = this.parentTop + this.parentHeight / 2
      arr = arr.sort((pre, next) => {
        const {
          height: preHeight,
          bottom: preBottom
        } = pre.getBoundingClientRect()
        const {
          height: nextHeight,
          bottom: nextBottom
        } = next.getBoundingClientRect()
        return (
          Math.abs(preBottom - preHeight / 2 - centerY) -
          Math.abs(nextBottom - nextHeight / 2 - centerY)
        )
      })
      const index = parseInt(arr[0].dataset.index, 10)
      this.y = -index * (this.parentHeight / 5)
      this.tempY = this.y
      return index
    },
    // 回调前需要等待100毫秒，否则位移计算会有误差
    final () {
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.current = this.computePosition()
        // 回调放在最终位移后
        this.$emit('scrollend')
        this.$emit('selectChange', this.options[this.current])
      }, 100)
    },
    // 速度衰减动画动画
    animate () {
      if (this.checkBorder()) {
        this.final()
        return
      }
      const flag = this.speed > 0
      const rate = 0.3
      this.requestId = requestAnimationFrame(() => {
        this.tempY += this.speed
        this.y = this.tempY
        if (flag) this.speed -= rate
        if (!flag) this.speed += rate
        if (this.speed >= -rate && this.speed <= rate) {
          this.final()
          return
        }
        this.animate()
      })
    },
    // 边界检查，会否超出所有
    checkBorder () {
      if (!this.$refs.slider) return true
      const height = this.unitHeight * (this.options.length - 1)
      if (this.y < -height) {
        this.tempY = this.y = -height
        return true
      }
      if (this.y > 0) {
        this.tempY = this.y = 0
        return true
      }
      return false
    },
    // 触摸开始, 记录第一次触摸的点
    moveStart ({ touches }) {
      cancelAnimationFrame(this.requestId)
      this.touchStartY = touches[0].clientY
      this.startTime = new Date()
    },
    // 触摸移动，每次都更改y即实际滑动元素的translateY
    move (e) {
      const { touches } = e
      this.y = this.tempY + touches[0].clientY - this.touchStartY
    },
    // 触摸结束，计算速度，缓存上一次的最终位移
    moveEnd ({ changedTouches }) {
      if (this.options.length === 0) return
      this.endTime = new Date()
      const offsetY = changedTouches[0].clientY - this.touchStartY
      this.speed =
        (offsetY / (this.endTime.getTime() - this.startTime.getTime())) * 16.6
      this.touchStartY = changedTouches[0].clientY
      this.tempY = this.y
      this.$emit('scrolling')
      this.animate()
    }
  },
  mounted () {
    // 等待动画完成后再计算父元素的位置
    setTimeout(() => {
      const parentRect = this.$refs.parent.getBoundingClientRect()
      this.parentHeight = parentRect.height
      this.parentTop = parentRect.top
      this.unitHeight = parentRect.height / 5
      if (this.options.length === 0) return
      this.$emit('selectChange', this.options[this.current])
      if (this.value || typeof this.value === 'number') this.init()
    }, 200)
  }
}
</script>
